(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .controller('ConsortiumPersonalNominaNewController', ConsortiumPersonalNominaNewController);

        ConsortiumPersonalNominaNewController.$inject = ['$rootScope', '$timeout', '$scope', 'entity', 'ConsortiumPersonalNomina', '$state', 'previousState', 'toastr', 'DateUtils', '$mdSidenav', 'ConsortiumUsers'];

    function ConsortiumPersonalNominaNewController($rootScope, $timeout, $scope, entity, ConsortiumPersonalNomina, $state, previousState,toastr, DateUtils, $mdSidenav, ConsortiumUsers) {
        var vm = this;

        vm.consortiumPersonalNomina = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler('left');
        vm.months = ["ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO","JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"];

        ConsortiumUsers.query({}, onSuccess, onError);
        
        function onSuccess(data, headers) {
            vm.consortiumUsers = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var consortiumPersonalNomina = Object.assign({}, vm.consortiumPersonalNomina);
            consortiumPersonalNomina.id = null;
            ConsortiumPersonalNomina.save(consortiumPersonalNomina, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Creado con éxito!');
            vm.isSaving = false;
            $state.go('consortium-personal-nominas', {
            });
        }

        function onSaveError() {
            toastr.error('Error al crear la nómina');
            vm.isSaving = false;
        }
        
        function buildToggler(navID) {
            return function() {
              // Component lookup should always be available since we are not using `ng-if`
              $mdSidenav(navID).toggle().then(function () {
              });
              };
        }
    }
})();
